import { render } from "./BaseTimer.vue?vue&type=template&id=0f20aa27&scoped=true"
import script from "./BaseTimer.vue?vue&type=script&lang=js"
export * from "./BaseTimer.vue?vue&type=script&lang=js"

import "./BaseTimer.vue?vue&type=style&index=0&id=0f20aa27&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src396721354/src/serverlesspressoV3/frontends/vue-display-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f20aa27"]])

export default __exports__